export default {
  name: 'tabs',
  component(settings) {
    return {
      // Initialize component
      activeTab: null,
      tabTitles: [],

      get tabItems() {
        return this.$el.querySelectorAll('.tab-item');
      },

      get tabButtons() {
        return this.$el.querySelectorAll('.tab-button');
      },

      init() {
        // Collect tab titles from DOM
        this.collectTabTitles();
        
        // Initialize the active tab
        this.initializeActiveTab();
        
        // Set initial container height
        this.$nextTick(() => {
          if (this.activeTab) {
            this.updateContainerHeight(this.activeTab);
          }
        });
      },

      // Collect tab titles from the DOM elements
      collectTabTitles() {
        this.tabTitles = [];
        this.tabItems.forEach((item, index) => {
          const blockId = item.dataset.blockId;
          
          // Try to get title from data attribute first
          let title = item.dataset.title;
          
          // If no data-title, look for title in any form elements or text content
          if (!title) {
            // Look for any input with name containing 'title'
            const titleInput = item.querySelector('input[name*="title"], input[id*="title"]');
            if (titleInput) {
              title = titleInput.value;
            }
          }
          
          // Fallback to default title with index
          if (!title || title.trim() === '') {
            title = `Tab ${index + 1}`;
          }
          
          this.tabTitles.push({
            id: blockId,
            title: title,
            iconClass: item.dataset.iconClass || null,
            iconPosition: item.dataset.iconPosition || 'left',
            iconGap: item.dataset.iconGap || '8',
            iconSize: item.dataset.iconSize || '20'
          });
        });
      },

      // Initialize the active tab
      initializeActiveTab() {
        const items = Array.from(this.tabItems);

        // Prefer the first tab explicitly marked active_by_default
        const defaultTab = items.find(item => item.dataset.activeByDefault === 'true');
        if (defaultTab) {
          this.activeTab = defaultTab.dataset.blockId;
          return;
        }

        // Fall back to the first tab
        if (items.length > 0) {
          this.activeTab = items[0].dataset.blockId;
        }
      },

      // Set active tab
      setActiveTab(blockId) {
        // Update container height before switching
        this.updateContainerHeight(blockId);
        
        this.activeTab = blockId;
        
        // Update aria-selected attributes on tab buttons
        this.tabButtons.forEach((button, index) => {
          const isActive = button.getAttribute('aria-controls') === `tab-content-${blockId}`;
          button.setAttribute('aria-selected', isActive.toString());
        });
      },

      // Update container height to match the active tab content
      updateContainerHeight(newActiveTabId) {
        // No-op: height is managed by CSS (auto)
      },

      // Check if specific tab is active
      isActive(blockId) {
        return this.activeTab === blockId;
      },

      // Method to go to next tab
      nextTab() {
        const currentIndex = Array.from(this.tabItems).findIndex(
          item => item.dataset.blockId === this.activeTab
        );
        const nextIndex = (currentIndex + 1) % this.tabItems.length;
        const nextBlockId = this.tabItems[nextIndex].dataset.blockId;
        this.setActiveTab(nextBlockId);
      },

      // Method to go to previous tab
      prevTab() {
        const currentIndex = Array.from(this.tabItems).findIndex(
          item => item.dataset.blockId === this.activeTab
        );
        const prevIndex = currentIndex === 0 ? this.tabItems.length - 1 : currentIndex - 1;
        const prevBlockId = this.tabItems[prevIndex].dataset.blockId;
        this.setActiveTab(prevBlockId);
      },

      // Method to go to specific tab by index
      goToTab(index) {
        if (this.tabItems[index]) {
          const blockId = this.tabItems[index].dataset.blockId;
          this.setActiveTab(blockId);
        }
      }
    };
  }
};